export default {
    params_contact_wrong: {
        query: null
    },
    params_contact_correct: {
        query: null,
        only_valid_identification: true
    },
    contacts_find_wrong: [],
    contacts_find_correct: [],
    warehouses_wrong: [],
    warehouses_correct: [],
    unifyParam: {
        wrong_contact_id: null,
        correct_contact_id: null,
        wrong_warehouse_id: null,
        correct_warehouse_id: null
    },
    inconsistentContacts: [],
    loading: {
        module: false
    }
}



// WEBPACK FOOTER //
// ./src/modules/unify-contacts/state.js